import clsx from 'clsx';

import { Typography } from 'omakase';
import BaseComponent from '@tock/shared/components/BaseComponent';

interface TypeMapping {
  alert: {
    classString: string;
    iconClassString: string;
  };
}

const typeMapping: TypeMapping = {
  alert: {
    classString: 'Banner--alert',
    iconClassString: 'icon-alert',
  },
};

interface Props {
  children: JSX.Element | JSX.Element[];
  heading: string;
  type: 'alert';
}

export default class Banner extends BaseComponent<Props> {
  render() {
    const { children, heading, type } = this.props;

    const { classString, iconClassString } = typeMapping[type];

    const className = clsx('Banner', classString);
    const iconClassName = clsx('Banner-icon', 'icon', iconClassString);

    return (
      <div className={className}>
        <div className="Banner-content">
          <div className="Banner-iconContainer">
            <i className={iconClassName} />
          </div>

          <div className="Banner-text">
            <h4 className="Banner-heading">
              <Typography color="inherit" component="span" variant="body02">
                {heading}
              </Typography>
            </h4>

            <Typography color="inherit" component="span" variant="body02">
              {children}
            </Typography>
          </div>
        </div>
      </div>
    );
  }
}
